import { LoggerMessageType, LoggerProps } from 'interfaces/trackInterfaces';
import config from './config';
import { axios, path } from 'util/Api';
import { windowStore } from 'util/windowStore';

const stringifyMessage = (message: LoggerMessageType): string => {
  if (typeof message === 'string') return message;
  const { err, ...otherMessageProps } = message;
  let stringifiedErr = '';
  if (err) {
    try {
      stringifiedErr = JSON.stringify(err, Object.getOwnPropertyNames(err));
    } catch (e) {
      const errMessage = 'Error stringifying error object for Logger ';
      stringifiedErr = errMessage;
      // eslint-disable-next-line no-console
      console.error(errMessage, e);
    }
  }

  let stringifiedMessage = '';
  try {
    stringifiedMessage = JSON.stringify({ ...otherMessageProps, err: stringifiedErr });
  } catch (e) {
    const errMessage = 'Error stringifying message for Logger ';
    stringifiedMessage = JSON.stringify({
      message: errMessage,
      err: stringifiedErr,
    });
    // eslint-disable-next-line no-console
    console.error(errMessage, e);
  }
  return stringifiedMessage;
};

const createRequestObj = (props: LoggerProps, username?: string) => {
  const { message } = props;
  const { pathname, hash } = window.location;
  const sumoPage = pathname + hash;
  // To Remove when "src\config\config.js" is converted to TypeScript
  // @ts-ignore
  const { sourceCategory } = config.sumo as { sourceCategory: string };
  return {
    ...props,
    message: stringifyMessage(message),
    sourceCategory,
    // API expects sumo_page
    // eslint-disable-next-line camelcase
    sumo_page: sumoPage,
    username: username ?? 'unknown',
  };
};

export async function sendToLogger(props: LoggerProps) {
  const { accountId, username } = windowStore;
  const reqObj = createRequestObj(props, username);
  try {
    if (accountId) {
      // API expects account_id
      // eslint-disable-next-line camelcase
      return await axios.post(path.TRACK_ACTIVE, { ...reqObj, account_id: accountId });
    }
    return await axios.post(path.TRACK_SESSION, reqObj);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(
      `Error logging to Logger ${accountId ? 'Authenticated' : 'Unauthenticated'}: `,
      err,
    );
    return null;
  }
}
